import React from "react";
import { useParams } from "react-router-dom";
import useTrackingViewItem from "@hooks/useTrackingViewItem";
import V2V3BookSession from "@components/V3/V3BookSession";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const TicketPurchasePage = () => {
    const { id } = useParams();
    
    // Google Analytics tracking for viewing items
    useTrackingViewItem();

    return (
        <VersionedLayout>
            <V2V3BookSession key={id} />
        </VersionedLayout>
    );
};

export default TicketPurchasePage;
